import { render, staticRenderFns } from "./AuthorityTransferCard.vue?vue&type=template&id=b24b292e&"
import script from "./AuthorityTransferCard.vue?vue&type=script&lang=js&"
export * from "./AuthorityTransferCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports